import {RegisterType} from '../component-registry';
import {GuidedUiSkeleton} from '../../models/Guided.schema';
import {h, type JSX} from '@stencil/core';
import {GuidedSkeleton} from './skeleton';

export class GuidedV2Skeleton {
  @RegisterType(GuidedUiSkeleton.type)
  render(inputData: GuidedUiSkeleton): JSX.Element {
      return <GuidedSkeleton
        itemWidth={inputData.itemWidth}
        itemHeight={inputData.itemHeight}
        resultSlots={inputData.resultSlots}
        displayMode={inputData.displayMode}
        label={inputData.label}
      ></GuidedSkeleton>;
  }
}
